export type SaveSuccessNotiContentProps = {
  title: string;
  description: string;
  buttonLabel: string;
  onOpen: () => void;
};

const SaveSuccessNotiContent = ({
  title,
  description,
  buttonLabel,
  onOpen
}: SaveSuccessNotiContentProps) => {
  return (
    <div className="flex flex-col gap-2 items-start">
      <p className="text-base font-bold text-txtHeading">{title}</p>
      <p className="text-sm text-txtHeading">{description}</p>
      <button
        className="w-fit p-0 h-fit text-sm text-royal-blue font-bold"
        type="button"
        onClick={onOpen}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default SaveSuccessNotiContent;
